'use client';

import moment from 'moment';
import type { PickersCalendarHeaderProps } from '@mui/x-date-pickers/PickersCalendarHeader';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';

type Props = PickersCalendarHeaderProps & {
  onGoToToday?: () => void;
};

const MiniCalendarHeader = ({ currentMonth, onMonthChange, onGoToToday, labelId }: Props) => {
  const handleGoToToday = () => {
    onMonthChange(moment().startOf('month'));
    onGoToToday?.();
  };

  return (
  <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, pl: 1, pr: 0.5 }}>
    <ButtonBase
      id={labelId}
      onClick={handleGoToToday}
      sx={{
        flexGrow: 1,
        justifyContent: 'flex-start',
        borderRadius: 1,
        px: 0.5,
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {currentMonth.format('MMMM YYYY')}
      </Typography>
    </ButtonBase>
    <IconButton size="small" onClick={() => onMonthChange(currentMonth.clone().subtract(1, 'month'))}>
      <ChevronLeft />
    </IconButton>
    <IconButton size="small" onClick={() => onMonthChange(currentMonth.clone().add(1, 'month'))}>
      <ChevronRight />
    </IconButton>
  </Box>
  );
};

export default MiniCalendarHeader;
